import { useEffect } from "react";
import type { ReactNode } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "./msalConfig";
import { AppUserProvider, useAppUser } from "../app/AppUserContext";

function RedirectToLogin() {
  const { instance, inProgress } = useMsal();
  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      instance.loginRedirect(loginRequest);
    }
  }, [instance, inProgress]);
  return null;
}

function LoadingScreen() {
  return (
    <div className="py-[60px] px-7 text-center text-rs-light-gray">
      <span className="material-symbols-sharp animate-spin text-[28px]">progress_activity</span>
    </div>
  );
}

function AppUserGate({ children }: { children: ReactNode }) {
  const { loading } = useAppUser();
  if (loading) return <LoadingScreen />;
  return <>{children}</>;
}

export function RequireAuth({ children }: { children: ReactNode }) {
  return (
    <>
      <AuthenticatedTemplate>
        <AppUserProvider>
          <AppUserGate>{children}</AppUserGate>
        </AppUserProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <RedirectToLogin />
      </UnauthenticatedTemplate>
    </>
  );
}
